<template>
  <el-menu unique-opened :default-active="activeMenuIndex" :default-openeds="defaultOpeneds" class="el-menu-sidebar" active-text-color="#333333" @select="menuSelect">
    <side-menu-item v-for="menu in menus" :key="menu.id" :item="menu" />
  </el-menu>
</template>

<script>
import SideMenuItem from './sidemenuitem'
export default {
  name: 'SideMenu',
  props: {
    parent: {
      type: Object,
      default: () => null
    },
    menus: {
      type: Array,
      default: () => []
    },
    defaultOpeneds: {
      type: Array,
      default: () => []
    },
    activeMenuIndex: {
      type: String,
      default: '1'
    }
  },
  methods: {
    menuSelect: function (_index) {
      // this.$emit('menu-select', _index)
      this.parent.handlerMenuSelect(_index)
    }
  },
  components: {
    SideMenuItem
  }
}
</script>
